module.exports = __webpack_public_path__ + "img/user.82e1deb8.png";